"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";

// Bottom-right on desktop, top on phones (below the md breakpoint).
const PHONE_QUERY = "(max-width: 767px)";

/**
 * The app's one toast host (mounted once in the root layout). Success toasts
 * disappear after 5 s; errors are given `duration: Infinity` by the caller
 * and stay until dismissed. Sonner's list is an aria-live="polite" region.
 */
const Toaster = () => {
    const { resolvedTheme } = useTheme();
    const [phone, setPhone] = useState(false);

    useEffect(() => {
        const query = window.matchMedia(PHONE_QUERY);
        const update = () => setPhone(query.matches);
        update();
        query.addEventListener("change", update);
        return () => query.removeEventListener("change", update);
    }, []);

    return (
        <Sonner
            theme={resolvedTheme === "dark" ? "dark" : "light"}
            position={phone ? "top-center" : "bottom-right"}
            duration={5000}
            closeButton
            toastOptions={{ classNames: { title: "whitespace-pre-line" } }}
            style={
                {
                    "--normal-bg": "var(--popover)",
                    "--normal-text": "var(--popover-foreground)",
                    "--normal-border": "var(--border)",
                    "--success-bg": "var(--success-subtle)",
                    "--success-text": "var(--success)",
                    "--success-border": "var(--success)",
                    "--error-bg": "var(--danger-subtle)",
                    "--error-text": "var(--danger)",
                    "--error-border": "var(--danger)",
                } as React.CSSProperties
            }
        />
    );
};

export { Toaster };
